module.exports = __webpack_public_path__ + "static/media/percent.a7a7b4df.svg";